import {HttpClient, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {GenAverageCurve} from '../generated/serverModels/GenAverageCurve';
import {GenAverageCurvePeriod} from '../generated/serverModels/GenAverageCurvePeriod';
import {GenWeatherCounty} from '../generated/serverModels/GenWeatherCounty';
import {GenWeatherCountyDetail} from '../generated/serverModels/GenWeatherCountyDetail';
import {GenWeatherCountyResponse} from '../generated/serverModels/GenWeatherCountyResponse';
import {GenWeatherCurve} from '../generated/serverModels/GenWeatherCurve';
import {GenWeatherEvent} from '../generated/serverModels/GenWeatherEvent';
import {GenWeatherMetadata} from '../generated/serverModels/GenWeatherMetadata';

// Keep the domain-facing names stable while sourcing every API shape from Remodel.
export type AverageCurve = GenAverageCurve;
export type AverageCurvePeriod = GenAverageCurvePeriod;
export type WeatherCounty = GenWeatherCounty;
export type WeatherCountyDetail = GenWeatherCountyDetail;
export type WeatherCountyResponse = GenWeatherCountyResponse;
export type WeatherCurve = GenWeatherCurve;
export type WeatherEvent = GenWeatherEvent;
export type WeatherMetadata = GenWeatherMetadata;

@Injectable({providedIn: 'root'})
export class EdgarPipelineService {
  private readonly http = inject(HttpClient);

  public getCurvePeriods(): Observable<AverageCurvePeriod[]> {
    return this.http.get<GenAverageCurvePeriod[]>('/api/metrics/src-curve-periods')
      .pipe(map(rows => GenAverageCurvePeriod.jsonResponseToList(rows)));
  }

  public getAverageCurves(datasetKey?: string, states: string[] = []): Observable<AverageCurve[]> {
    let params = new HttpParams();
    if (datasetKey) params = params.set('datasetKey', datasetKey);
    if (states.length > 0) params = params.set('state', states.join(','));
    return this.http.get<GenAverageCurve[]>('/api/metrics/src-curve-info', {params})
      .pipe(map(rows => GenAverageCurve.jsonResponseToList(rows)));
  }

  public getWeatherMetadata(): Observable<WeatherMetadata> {
    return this.http.get<GenWeatherMetadata>('/api/weather-outage/metadata')
      .pipe(map(value => new GenWeatherMetadata(value)));
  }

  public getWeatherCounties(category: string, states: string[] = []): Observable<WeatherCountyResponse> {
    let params = new HttpParams().set('category', category);
    if (states.length > 0) params = params.set('state', states.join(','));
    return this.http.get<GenWeatherCountyResponse>('/api/weather-outage/counties', {
      params,
    }).pipe(map(value => new GenWeatherCountyResponse(value)));
  }

  public getWeatherCounty(fips: string): Observable<WeatherCountyDetail> {
    return this.http.get<GenWeatherCountyDetail>(`/api/weather-outage/counties/${encodeURIComponent(fips)}`)
      .pipe(map(value => new GenWeatherCountyDetail(value)));
  }
}
